import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';

const DEFAULT_BG = "https://customer-assets.emergentagent.com/job_roof-clean-heroes/artifacts/gftxsenc_Screenshot%202026-01-28%20121948.jpg";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function imageUrl(path) {
  if (!path) return DEFAULT_BG;
  if (path.startsWith('http')) return path;
  return `${API}/files/${path}`;
}

const Hero = () => {
  const [bgImage, setBgImage] = useState(DEFAULT_BG);

  useEffect(() => {
    fetch(`${API}/content/hero`).then(r => r.json()).then(data => {
      if (data.background_image_path) setBgImage(imageUrl(data.background_image_path));
    }).catch(() => {});
  }, []);

  return (
    <section className="relative pt-32 pb-24 px-4 sm:px-6 lg:px-8 overflow-hidden min-h-[700px]">
      <div className="absolute inset-0 z-0">
        <img src={bgImage} alt="Vancouver Skyline" className="w-full h-full object-cover" />
      </div>
      <div className="absolute top-20 right-10 w-72 h-72 bg-green-500 rounded-full blur-3xl opacity-10"></div>
      <div className="absolute bottom-10 left-10 w-96 h-96 bg-emerald-500 rounded-full blur-3xl opacity-10"></div>
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8 max-w-3xl">
            <h1 className="text-5xl lg:text-7xl font-bold text-white leading-tight" style={{textShadow: '2px 2px 4px rgba(0,0,0,0.8), 0 0 10px rgba(0,0,0,0.5)', fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'}}>
              Quality You Deserve
            </h1>
            <div className="space-y-3">
              <p className="text-lg lg:text-xl text-white leading-relaxed font-medium" style={{textShadow: '2px 2px 4px rgba(0,0,0,0.8), 0 0 8px rgba(0,0,0,0.6)'}}>
                Expert roof, gutter, and exterior cleaning services for residential and commercial properties across Vancouver and surrounding areas.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button
                size="lg"
                variant="outline"
                className="border-3 border-gray-900 text-gray-900 bg-white/80 hover:bg-white hover:text-green-700 hover:border-green-700 px-10 py-7 text-lg font-bold transition-all backdrop-blur-sm transform hover:scale-105 shadow-lg"
                onClick={() => {
                  const element = document.getElementById('booking');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                Contact Us
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
